//#region import
import React, { Fragment, createContext, useContext, useEffect, useState } from 'react';
import { ProjectContext } from '../ProjectRequestFrom';
import { FnAxios, FnDialog, I18n, ParseHtml } from 'utilities/utilities';
import { APIStatusCode, EnumProjectPanel, EnumProjectStatusID, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import { ApiProject } from 'enum/api';
import { Chip, Divider, Grid, Tooltip, Typography } from '@mui/material';
import { BtnCancel, BtnDraft, BtnEdit, BtnSend, BtnSendRequest } from 'components/Button/ButtonAll';
import ErrorIcon from '@mui/icons-material/Error';
import { FormProvider, useForm } from 'react-hook-form';
import { DateRangePickerItem } from 'components/Input/DatePicker/DateRangePickerItem';
import AccordionPanel from '../components/AccordionPanel';
import moment from 'moment';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { useLocation } from 'react-router';
//#endregion

const Panel6 = () => {
    const {
        nProjectID,
        setnProjectID,
        isFastTrack,
        isPermission,
        ObjProjectRequest,
        arrisEditPanel,
        setarrisEditPanel,
        nStatusID,
        isChangePanel12,
        setisChangePanel12,
        isChangePanel6,
        setisChangePanel6,
        isSubmit,
        setisSubmit,
        ObjStepFlowProject,
        isModeSecretary,
        nProjectVersionID,
        nLogChangeID,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();

    const [isEditSecretary, setisEditSecretary] = useState(null);
    const [isComplete, setisComplete] = useState(null);

    const currentDate = new Date(); // Get the current date
    // const _dStart = new Date(currentDate.getFullYear(), 0, 1); //01/01/New + 1
    // const _dEnd = new Date(currentDate.getFullYear(), 12, 0); //31/12/New + 1
    const [_dStart, setdStart] = useState(new Date(currentDate.getFullYear(), 0, 1)); //01/01/New + 1
    const [_dEnd, setdEnd] = useState(new Date(currentDate.getFullYear(), 12, 0)); //31/12/New + 1

    const [lstProjectDateTimeAll, setlstProjectDateTimeAll] = useState([]);    
    const [dStartMonitor, setdStartMonitor] = useState<any>(null);
    const [dEndMonitor, setdEndMonitor] = useState<any>(null);

    //การขยายระยะเวลาแผน
    const [nProgressStatusID, setnProgressStatusID] = useState(null);
    const [nCurrentYear, setnCurrentYear] = useState(null);
    const [nCurrentQ, setnCurrentQ] = useState(null);

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            // dProjectDateRange: [_dStart, _dEnd],
            // dProjectDateRange: [null, null],
            sDateStart: null,
            sDateEnd: null,
        } as any,
    });

    useEffect(() => {
        setisEditSecretary((isModeSecretary === true || nLogChangeID !== null) ? false : isPermission);
    }, [isModeSecretary, nLogChangeID]);

    useEffect(() => {
        if (isChangePanel6 === true || nLogChangeID !== null) GetFormInitial();
    }, [isChangePanel6, nLogChangeID]);

    useEffect(() => {
        GetFormInitial();     
        if (nProjectID !== 0) handleGetFormProjectID();
    }, [nProjectID, isFastTrack]);

    useEffect(() => {
        if (nProjectVersionID !== 0) handleGetFormProjectID();
    }, [nProjectVersionID]);

    const GetFormInitial = () => {
        AxiosFn.Get(ApiProject.GetFormInitialProjectPanel6, {nProjectID : nProjectID, isFastTrack: isFastTrack, nLogChangeID: nLogChangeID}, (result) => {
            setdStart(new Date(result.nStartDate));
            setdEnd(new Date(result.nEndDate));

            // หาช่วงเวลาทั้งหมดใน Panel 12 ว่าการเปลี่ยนของ Panel 6 ยังอยู่ในช่วงเวลาที่ทำการเพิ่มไว้ 12 หรือไม่ ถ้าเกินช่วงเวลาของ 12 จะต้องแจ้งเตือนและให้กลับไปแก้ 12 ก่อน
            // หาช่วงเวลาทั้งหมดใน Plan Type WorkPlan & SpendingPlan >> TbProjectActivityPlan
            setlstProjectDateTimeAll(result.lstProjectDateTimeAll);
            setdStartMonitor(result.nStartMonitorDate ? new Date(result.nStartMonitorDate) : null);
            setdEndMonitor(result.nEndMonitorDate? new Date(result.nEndMonitorDate) : null);
            setisChangePanel6(false);

            //การขยายระยะเวลาแผน
            setnProgressStatusID(result.nProgressStatusID);
            setnCurrentYear(result.nCurrentYear);
            setnCurrentQ(result.nCurrentQ);
        });
    }

    const handleGetFormProjectID = () => {
        // DialogFn.BlockUI();
        AxiosFn.Get(ApiProject.GetFormProjectID_Panel6, { nProjectID: nProjectID, nProjectVersionID: (nProjectVersionID === 0 ? null : nProjectVersionID), }, (result) => {
            // DialogFn.UnBlockUI();
            setnProjectID(result.objResult.nProjectID);
            // setnStatusID(result.objResult.nStatusID);
            setisComplete(result.objResult.isComplete);
            // form.setValue("dProjectDateRange", [result.objResult.nProjectStartDate ? moment(result.objResult.nProjectStartDate) : null, result.objResult.nProjectEndDate ? moment(result.objResult.nProjectEndDate) : null]);
            form.setValue("sDateStart", result.objResult.nProjectStartDate ? moment(result.objResult.nProjectStartDate) : null);
            form.setValue("sDateEnd", result.objResult.nProjectEndDate ? moment(result.objResult.nProjectEndDate) : null);
        });
    };

    const handleSubmit = (nModeID: EnumSaveModeProject) => {
        let ObjData = form.getValues(); 
        let dStartData = moment(ObjData.sDateStart);
        let dEndData = moment(ObjData.sDateEnd);
        let _dStartMonitor = moment(dStartMonitor);
        let _dEndMonitor = moment(dEndMonitor);
        if (dStartData > _dStartMonitor || dEndData < _dEndMonitor || dStartData > _dEndMonitor || dEndData < _dStartMonitor) {
            // return DialogFn.Warning("กรุณาตรวจสอบข้อมูล ระยะเวลา เนื่องจากมีข้อมูลใน หัวข้อ 12. การติดตามนิเทศโครงการ มีรายการไม่ได้อยู่ในช่วงระยะเวลา กรูณาทำการตรวจสอบและแก้ไขให้เรียบร้อย");

            // หาช่วงเวลาทั้งหมดใน Panel 12 ว่าการเปลี่ยนของ Panel 6 ยังอยู่ในช่วงเวลาที่ทำการเพิ่มไว้ 12 หรือไม่ ถ้าเกินช่วงเวลาของ 12 จะต้องแจ้งเตือนและให้กลับไปแก้ 12 ก่อน
            // หาช่วงเวลาทั้งหมดใน Plan Type WorkPlan & SpendingPlan >> TbProjectActivityPlan
            return DialogFn.Warning("กรุณาตรวจสอบข้อมูลระยะเวลา เนื่องจากมีการใช้ช่วงเวลาข้อมูลในส่วนอื่นอยู่ <br/> - กท. 1 : หัวข้อ 12. การติดตามนิเทศโครงการ <br/> - กท. 2 : กท. 2/1 และ กท. 2/2 <br/> มีรายการไม่ได้อยู่ในช่วงระยะเวลา กรุณาทำการตรวจสอบและแก้ไขให้เรียบร้อย.");
        }
        // if (((ObjData.dProjectDateRange || []).length > 0 ? ObjData.dProjectDateRange[0] === null && ObjData.dProjectDateRange[1] === null : false) && nModeID === EnumSaveModeProject.Submit) {
        //     return DialogFn.Warning("กรุณากรอกข้อมูลให้ครบถ้วน");
        // } 
        if (ObjData.sDateStart === null && ObjData.sDateEnd === null && nModeID === EnumSaveModeProject.Submit) {
            return DialogFn.Warning("กรุณากรอกข้อมูลให้ครบถ้วน");
        } 

        //การขยายระยะเวลาแผน > ถ้าเขามาปรับแก้ ให้น้อยกว่าไตรมาสที่เคยทำมาแล้วไม่ได้ แต่เท่ากับไตรมาสปัจุบันได้ ถ้าเท่ากับไตรมาสที่กำลังรายงานไม่สนเดือน และถ้ามากกว่า ก็ไม่ต้องดันอะไร แต่ไปทำในส่วยตอน ยันยืนการปรับปรุง ค่อยไป รี > (dProjectEnd.nYear >= nCurrentYear && (dProjectEnd.Month แปลเป็น Q) >= nCurrentQ)
        if (nProgressStatusID !== null && nModeID === EnumSaveModeProject.Submit) 
        {
            let nYearEnd = parseInt(dEndData.format("YYYY"));
            let nMonthEnd = parseInt(dEndData.format("M"));
            let nCurrentQ_End = 0;
            switch (nMonthEnd)
            {
                case 1:
                case 2:
                case 3:
                    nCurrentQ_End = 1;
                    break;
                case 4:
                case 5:
                case 6:
                    nCurrentQ_End = 2;
                    break;
                case 7:
                case 8:
                case 9:
                    nCurrentQ_End = 3;
                    break;
                case 10:
                case 11:
                case 12:
                    nCurrentQ_End = 4;
                    break;
            }
            //(dProjectEnd.nYear >= nCurrentYear && (dProjectEnd.Month แปลเป็น Q) >= nCurrentQ) > ผ่าน
            if  ((nYearEnd <= nCurrentYear && nCurrentQ_End < nCurrentQ) || (nYearEnd < nCurrentYear)) {
                return DialogFn.Warning("ไม่สามารถปรับวันที่สิ้นสุดระยะเวลาโครงการน้อยกว่าแผนที่เคยรายงานผลไปแล้วได้");
            } 
        }
        
        let param = {
            nProjectID: nProjectID,
            nSaveModeProject: nModeID,
            nPanelID: EnumProjectPanel.Panel6,
            isFastTrack: isFastTrack,

            // nProjectStartDate:  ObjData.dProjectDateRange && ObjData.dProjectDateRange[0] ? ObjData.dProjectDateRange[0].valueOf() : null,
            // nProjectEndDate: ObjData.dProjectDateRange && ObjData.dProjectDateRange[1] ? ObjData.dProjectDateRange[1].valueOf() : null,
            nProjectStartDate:  ObjData.sDateStart ? ObjData.sDateStart.valueOf() : null,
            nProjectEndDate: ObjData.sDateEnd ? ObjData.sDateEnd.valueOf() : null,

            sLocation: location.pathname,
            nLogChangeID: nLogChangeID,
        };
        DialogFn.Submit(nModeID === EnumSaveModeProject.Draft
                        ? I18n.SetText("Message.ConfirmSaveDraft", I18NextNs.labelComponent) 
                        : I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectPanel6, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        setnProjectID(result.objResult?.nProjectID);
                        setisComplete(nModeID === EnumSaveModeProject.Draft ? false : true);
                        // setarrisEditPanel({nPanelID: 6, isEdit: false});
                        setisChangePanel12(true);
                        setisSubmit(isSubmit === true ? false : true);
                        if(isEditSecretary && isModeSecretary === true) setisEditSecretary(false);
                    });
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    return (
        <AccordionPanel
            header={"6. ระยะเวลาดำเนินการ"}
            isExpanded={true} 
            // SubHeader={}
            color="white"
            bgColor="rgb(102,151,245)"
            background="#5598fc"
            expandIconColor="white"
            borderColor="1px solid #5598fc"
            borderRadius="18px !important"
            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
            SubHeaderStatus={
                (isComplete !== null &&
                    <Chip
                        size="small"
                        label={ParseHtml(isComplete === false ? 'บันทึกร่าง' : isComplete === true ? "บันทึกพร้อมส่ง" : "")}
                        style={{
                            color: "white",
                            backgroundColor: (isComplete === false ? '#f18c3a' : isComplete === true ? "#0a9914" : ""),
                            fontSize: "14px"
                        }}
                    />     
                )      
            }
            isDisabled={nProjectID === 0}
        >       
            <Grid id={"myDivPanel6"} item xs={12} md={12} container spacing={1} style={{ padding: '2%', paddingBottom: '1%', }}>
                <FormProvider {...form}>
                    <Grid item xs={12} md={12} container spacing={2}>
                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                            <Grid item>
                                <Typography variant='h6' color={'#0000a5'}>ระยะเวลาดำเนินการ</Typography>
                            </Grid>
                            <Grid item>
                                <Tooltip placement={'right-end'} title={"ระบุระยะเวลาเริ้มต้นและสิ้นสุดการดำเนินงานโครงการ"} >
                                    <ErrorIcon color='primary'/>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Divider />
                            </Grid>
                        </Grid>                                        
                        {/* <Grid item xs={12} md={12}>
                            <DateRangePickerItem
                                id={"dProjectDateRange"}
                                name={"dProjectDateRange"}
                                labelStart={"ระยะเวลาเริ่มต้น"}
                                labelEnd={"ระยะเวลาสิ้นสุด"}                                
                                required={true}
                                disabled={!isPermission || isEditSecretary === false}
                                minDate={_dStart}
                                maxDate={_dEnd}
                            />
                        </Grid>  */}
                        {/* <Grid item container spacing={2} xs={12} md={6}>                        
                            <Grid item xs={5.5}>
                                <DatePickerItem
                                    id={'sDateStart'}
                                    name={'sDateStart'}
                                    label={"ระยะเวลาเริ่มต้น"}
                                    fullWidth={true}
                                    required={true}
                                    minDate={_dStart}
                                    maxDate={form.watch("sDateEnd") || _dEnd}
                                    disabled={!isPermission || isEditSecretary === false}
                                />
                            </Grid>
                            <Grid item display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                -
                            </Grid>
                            <Grid item xs={5.5}>
                                <DatePickerItem
                                    id={'sDateEnd'}
                                    name={'sDateEnd'}
                                    label={"ระยะเวลาสิ้นสุด"}
                                    fullWidth={true}
                                    required={true}
                                    minDate={form.watch("sDateStart") || _dStart}
                                    maxDate={_dEnd}
                                    disabled={!isPermission || isEditSecretary === false}
                                />
                            </Grid>
                        </Grid> */}
                        <Grid item xs={12} md={7} container spacing={1} direction="row" alignItems="start">
                            <Grid item xs={11} md={5}>
                                <DatePickerItem
                                    id={'sDateStart'}
                                    name={'sDateStart'}
                                    label={"ระยะเวลาเริ่มต้น"}
                                    fullWidth={true}
                                    required={true}
                                    minDate={_dStart}
                                    maxDate={form.watch("sDateEnd") || _dEnd}
                                    disabled={!isPermission || isEditSecretary === false || nLogChangeID !== null}
                                    defaultCalendarMonth={moment(_dStart).startOf('year').year(_dStart.getFullYear())}
                                    // defaultCalendarMonth={_dStart ? moment(_dStart).startOf('year').year(_dStart.getFullYear()) : null}
                                    // minDate={moment().startOf('year').year(nYear)}
                                    // maxDate={moment().endOf('year').year(nYear)}
                                    // defaultCalendarMonth={moment().startOf('year').year(nYear)}
                                    IsDisablePortal={true}
                                />
                            </Grid>
                            <Grid item style={{marginTop: '2%'}}> - </Grid>
                            <Grid item xs={11} md={5}>
                                <DatePickerItem
                                    id={'sDateEnd'}
                                    name={'sDateEnd'}
                                    label={"ระยะเวลาสิ้นสุด"}
                                    fullWidth={true}
                                    required={true}
                                    minDate={form.watch("sDateStart") || _dStart}
                                    maxDate={_dEnd}
                                    disabled={!isPermission || isEditSecretary === false}
                                    defaultCalendarMonth={moment(_dStart).startOf('year').year(_dStart.getFullYear())}
                                    IsDisablePortal={true}
                                />
                            </Grid>
                        </Grid>     
                        <Grid item xs={12} md={12}>
                            <Typography variant='body2' color={'red'}>หมายเหตุ : ระบุระยะเวลาเริ่มต้นและสิ้นสุดการดําเนินงานโครงการ โดยกําหนดให้เริ่มดําเนินโครงการตั้งแต่เดือน มกราคม และควรสิ้นสุดการดําเนินงานภายในวันที่ 30 พฤศจิกายน ของปีบัญชีที่จะดําเนินโครงการ</Typography>
                        </Grid>
                        {nProjectID === 0 || (nStatusID === EnumProjectStatusID.nStatusID_11 && nLogChangeID === null) ?
                            <></>
                            :
                            (isPermission === true &&
                                (isModeSecretary !== true ?
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                        {nStatusID === EnumProjectStatusID.nStatusID_0 &&
                                            <Grid item>
                                                <BtnDraft id={"btnDraft_Panel6"} txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Draft) }} />
                                            </Grid>
                                        }
                                        <Grid item>
                                            <BtnSendRequest id={"btnSend_Panel6"} txt={I18n.SetText((nStatusID === EnumProjectStatusID.nStatusID_0 ? "Button.SendProjectPanel" : "Button.Save"), I18NextNs.labelComponent)} onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit),(err) => console.log("err", err))}/>
                                        </Grid> 
                                    </Grid>  
                                : 
                                    (isModeSecretary === true ?
                                        <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                            {isEditSecretary === false ?
                                                <Grid item>
                                                    <BtnEdit id={"btnEdit_Panel6"} txt={I18n.SetText("Button.Edit", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(true); document.getElementById("myDivPanel6").scrollIntoView({ behavior: "smooth" });}} />
                                                </Grid>
                                                :
                                                <>
                                                    <Grid item>
                                                        <BtnCancel id={"btnCancel_Panel6"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(false); handleGetFormProjectID(); }} />
                                                    </Grid>
                                                    <Grid item>
                                                        <BtnSendRequest id={"btnSend_Panel6"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit),(err) => console.log("err", err))} />
                                                    </Grid>
                                                </>
                                            }   
                                        </Grid>
                                        : <></>
                                    )
                                )
                            )
                        }
                    </Grid>
                </FormProvider>
            </Grid>
        </AccordionPanel>
    )
}
export default Panel6;
